import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MapPin } from "lucide-react";

/**
 * Rotating "Sarah from Melbourne bought the 4-Pack · 3 min ago" ticker.
 * Seeded Aussie first names + capital cities + pack labels. Each entry gets a
 * random minutes-ago so it feels organic. Never persisted — pure social-proof theatre.
 */
const NAMES = ["Sarah", "Ethan", "Olivia", "Jack", "Mia", "Noah", "Chloe", "Lachlan", "Zoe", "Oliver", "Amelia", "Tom", "Ruby", "Finn", "Grace", "Max", "Harper", "Hunter", "Charlie", "Isla"];
const CITIES = ["Melbourne", "Sydney", "Brisbane", "Perth", "Adelaide", "Hobart", "Canberra", "Darwin", "Gold Coast", "Newcastle", "Geelong", "Wollongong", "Ballarat", "Townsville", "Cairns"];
const PACKS = ["1-Pack", "2-Pack", "4-Pack", "8-Pack"];
const PACK_WEIGHTS = [10, 25, 45, 20]; // 4-Pack is the most common

const pickWeighted = (list, weights) => {
  const total = weights.reduce((a, b) => a + b, 0);
  let r = Math.random() * total;
  for (let i = 0; i < list.length; i++) {
    r -= weights[i];
    if (r <= 0) return list[i];
  }
  return list[list.length - 1];
};
const pick = (list) => list[Math.floor(Math.random() * list.length)];

const makeEntry = () => ({
  id: `${Date.now()}-${Math.random()}`,
  name: pick(NAMES),
  city: pick(CITIES),
  pack: pickWeighted(PACKS, PACK_WEIGHTS),
  mins: 1 + Math.floor(Math.random() * 14), // 1-14 min ago
});

export default function RecentBuysTicker() {
  const [entry, setEntry] = useState(() => makeEntry());

  useEffect(() => {
    const t = setInterval(() => setEntry(makeEntry()), 8000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="relative h-9 overflow-hidden rounded-full bg-tracksy-cream px-3" data-testid="cart-social-proof">
      <AnimatePresence mode="wait">
        <motion.div
          key={entry.id}
          initial={{ y: 14, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -14, opacity: 0 }}
          transition={{ duration: 0.35 }}
          className="flex h-9 items-center gap-2 text-xs font-semibold text-tracksy-ink"
        >
          <span className="flex h-2 w-2 shrink-0 animate-pulse rounded-full bg-tracksy-green" />
          <MapPin className="h-3 w-3 shrink-0 text-tracksy-sub" />
          <span className="truncate">
            <span className="font-extrabold">{entry.name}</span> from <span className="font-extrabold">{entry.city}</span> bought the {entry.pack}
            <span className="text-tracksy-sub"> · {entry.mins} min ago</span>
          </span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
